import Vue from 'vue';
import directive from './directive.js';
import filters from './filters.js';
import { script } from '@utils/script.js';
import { getEnv } from '@tencent/slug-function';
const { isSlugSDK, isMSDK } = getEnv();


Vue.use(directive);
Vue.use(filters);
Vue.prototype.isShowUGC = false;
// 禁止原生滚动
document.ontouchmove = (e) => {
  e.preventDefault();
};


async function initShare() {
  if (window.SlugShare == undefined) {
    await script({
      url: 'https://tiem-cdn.qq.com/slugteam/components/share/v1.0/slug-share.min.js',
    });
  }
  if (document.querySelector('.ig-sharemenu')) {
    document.querySelector('.ig-sharemenu').remove();
  }
  Vue.prototype.$share = new SlugShare({
    title: '和平精英微社区', // 不设置或设置为空时，页面有title，则调取title
    desc: '和平精英微社区', // 不设置或设置为空时，页面有Description，则调取Description
    imgUrl: 'https://gzhcos.qq.com/gp-ingame/img/logo.png', // 分享图片尺寸200*200，且填写绝对路径
    url: location.href, // 可选，分享页面链接，为空时默认为当前页面url
    actName: 'share', // 点击流名称，游戏外多页面分享时加上
    channels: ['wxt', 'wxf', 'qqf', 'qqz'],
    options: {
      msdkicon: 'https://game.gtimg.cn/images/gp/public/logo_200.png', // msdk截图分享支持
    },
  });
};
initShare();


function msdkFullscreen() {
  if ((!Boolean(document.referrer) || document.referrer.indexOf('sy.qq.com') >= 0) && isMSDK) {
    window.name = 'cur';
    loopFull();
    window.addEventListener('pageshow', () => {
      if (window.name !== 'cur') {
        loopFull();
      }
    });
    function setfullScreen() {
      const fullScreen = '{"MsdkMethod":"WGSetFullScreen","isFullScreen":"true"}';
      window.msdkCall('WGSetFullScreen', fullScreen);
    }
    function loopFull() {
      let times = 5;
      const loop = setInterval(() => {
        try {
          setfullScreen();
          clearInterval(loop);
        } catch (err) {
          times = times - 1;
          console.log('msdk全屏失败');
          if (times < 0) {
            clearInterval(loop);
          }
        }
      }, 1000);
    }
  }
}
msdkFullscreen();


// try {
//   (document.body).addEventListener('DOMSubtreeModified', (info) =>  {
//       console.log(info, info.timeStamp);
//       console.log(info.target && info.target.innerHTML)
//       debugger
//   }, false);
// } catch (err) {
//   console.log(err)
// }

// try {
//   const { serviceWorker } = navigator;
//   if (serviceWorker) {
//     /* #region 卸载 */
//     serviceWorker.getRegistrations
//       ? serviceWorker.getRegistrations().then((serviceWorkers) => {
//         serviceWorkers.forEach((item) => {
//           item.unregister();
//         });
//       })
//       : serviceWorker.getRegistration
//         && serviceWorker.getRegistration().then((serviceWorkers) => {
//           serviceWorkers && serviceWorkers.unregister();
//         });
//     /* #endregion */
//   }
// } catch (error) {
//   console.error(error);
// }


